import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { login } from 'services/api-service/center';
import { ActionCtorUser } from 'store/modules/user';

const LinkPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const user = searchParams.get('user');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchLogin = async (id: string) => {
    setLoading(true);
    setError(false);
    try {
      const response = await login(id, 'koast0860');
      if (response.result === 'success') {
        dispatch(ActionCtorUser.setUser(response));
        sessionStorage.setItem('isAuthenticated', 'true');
        navigate('/center');
      } else {
        sessionStorage.setItem('isAuthenticated', 'false');
        setError(true);
      }
    } catch (error) {
      sessionStorage.setItem('isAuthenticated', 'false');
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchLogin(user);
    } else {
      setError(true);
    }
  }, [user]);

  if (loading) {
    return (
      <BaseWrap>
        <CenterWrap>로그인 중...</CenterWrap>
      </BaseWrap>
    );
  }

  if (error) {
    return (
      <BaseWrap>
        <CenterWrap>로그인 후 사용바랍니다.</CenterWrap>
      </BaseWrap>
    );
  }

  return (
    <BaseWrap>
      <CenterWrap>로그인 후 사용바랍니다.</CenterWrap>
    </BaseWrap>
  );
};

const BaseWrap = styled.div`
  width: 100%;
  min-height: 100%;
  background: #002343;
`;
const CenterWrap = styled.div`
  position: absolute;
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  color: #fff;
  background: #002343;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  align-items: center;
`;

export default LinkPage;
